import React, { PropTypes, useCallback } from 'react'
import Dropzone from 'react-dropzone'

// 5 megabyte size limit
const IMAGE_SIZE_LIMIT = 5242880;

export default class LeaderStoryPhoto extends React.Component {

  static propTypes = {
    picture: PropTypes.string,
    style: PropTypes.object,
    onChanged: PropTypes.func.isRequired,
  };

  constructor(props) {
    super();
    this.state = {

    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.picture != this.props.picture) {
      // if user picture is updated, reset setState
      this.setState({
        newImg: null
      });
    }

  }

  onImageDrop(files) {
    this.setState({ newImg: files[0] });
    this.props.onChanged(files[0], this.props.pk);
  }

  render() {
    let { picture, style, imgWidth, imgHeight } = this.props;
    let { newImg } = this.state;
    let extraClass = (picture ? '': 'leaderStory-dropBoxEmpty');

    return (
      <Dropzone
        onDrop = {this.onImageDrop.bind(this)}
        multiple = {false}
        accept = {"image/*"}
        maxSize = {IMAGE_SIZE_LIMIT}
        className = {`leaderStory-dropBox ${extraClass}`}
        style = {{...style}}
      >
        <img src={newImg && newImg.preview || picture} />
      </Dropzone>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/leaderStory/LeaderStoryPhoto.jsx